import type FiltersBox from '@components/ui/hotel&view/sort&filter/FiltersBox.vue';
import type SortBox from '@components/ui/hotel&view/sort&filter/SortBox.vue';

export function useFilters() {
    const sortRef = ref<InstanceType<typeof SortBox>>();
    const filtersRef = ref<InstanceType<typeof FiltersBox>>();
    const applyFilters = (): void => {
        filtersRef.value?.apply();
        sortRef.value?.apply();
    };
    const refreshFilters = (): void => {
        filtersRef.value?.apply();
        sortRef.value?.apply();
    };
    // wtf is this
    const { open, close, isShow } = useMobileModalRouter({
        hash: 'filters',
        onOpen: refreshFilters,
    });

    return {
        openFilters: open,
        closeFilters: close,
        showFiltersInMobile: isShow,
        applyFilters,
        sortRef,
        filtersRef,
    };
}
